export const modePaiementCb = [
    'amex',
    'jade',
    'jcb',
    'emv',
    'emv_touch',
    'emv_multiple',
    'amex_touch',
    'amex_multiple',
];